<template>
  <el-dialog
    :title="(isEdit ? '编辑' : '添加') + '系统参数'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="450px"
    top="30px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="150px"
    >
      <el-form-item label="参数键名" prop="Key" :title="form.Key">
        <el-input
          v-model="form.Key"
          v-model.trim="form.Key"
          placeholder="参数键名"
          v-maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item label="参数值" prop="Value" :title="form.Value">
        <el-input
          v-model="form.Value"
          v-model.trim="form.Value"
          placeholder="参数值"
          v-maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用" prop="IsUsing">
        <el-select v-model="form.IsUsing" clearable>
          <el-option :value="1" label="启用"></el-option>
          <el-option :value="0" label="不启用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="参数说明" prop="Explain">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="参数说明"
          v-maxlength="200"
          v-model="form.Explain"
        >
        </el-input>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ["item"],

  data() {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      form: {},
      rules: {
        IsUsing: [
          {
            required: true,
            message: "是否启用",
            trigger: "change",
          },
        ],
        Key: [
          {
            required: true,
            message: " 不可为空",
          },
        ],
        Value: [
          {
            required: true,
            message: " 不可为空",
          },
        ],
        Explain:[
          this.$g.validLen(100)
        ],
      },
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        if (v.SettingCode) {
          this.isEdit = true;
          this.$get("BizAppSettings/GetItem", {
            SettingCode: v.SettingCode,
          }).then((r) => {
            this.init({ ...r.Result });
          });
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let values = { ...this.form };
        values.IsEdit = this.isEdit;
        this.loading = true;
        this.$post("BizAppSettings/AddEdit", values)
          .then((r) => {
            if (this.isEdit) {
              this.$message.success("修改成功");
            } else {
              this.$message.success("添加成功");
            }
            this.visible = false;
            this.$emit("success");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style>
</style>